import { render } from "./redirect.vue?vue&type=template&id=476ab242&scoped=true&ts=true"
import script from "./redirect.vue?vue&type=script&lang=ts"
export * from "./redirect.vue?vue&type=script&lang=ts"

import "./redirect.vue?vue&type=style&index=0&id=476ab242&lang=scss&scoped=true"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476ab242"]])

export default __exports__